<template>
  <CModal
    size="lg"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem 7.8125rem">
        <CRow class="modal-title">
          <CCol>
            <div class="modal-title">Add Owner</div>
          </CCol>
        </CRow>
        <CRow alignHorizontal="between" class="modal-detail">
          <CCol>
            <div class="input-label">Name</div>
            <input placeholder="NAME" class="input input-text" />
          </CCol>
          <CCol>
            <div class="input-label">Surname</div>
            <input placeholder="SURNAME" class="input input-text" />
          </CCol>
        </CRow>
        <CRow alignHorizontal="center" class="modal-detail">
          <CCol>
            <div class="input-label">E-mail</div>
            <input placeholder="E-mail" class="input input-text" style="width:100%" />
          </CCol>
        </CRow>
        <CRow alignHorizontal="center">
          <div
            @click="setModalVisible()"
            class="button button-pink"
            style="margin-left: 0.9375rem; margin-right: 0.9375rem"
          >CANCEL</div>
          <div
            class="button button-green"
            style="margin-left: 0.9375rem; margin-right: 0.9375rem"
          >CONFIRM</div>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "./closeButton";
export default {
  name: "AddUser",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function
  },
  components: {
    closeButton
  }
};
</script>

<style>
</style>